import { jsxs as r, jsx as C } from "react/jsx-runtime";
function o(l) {
  return /* @__PURE__ */ r("svg", { fill: "currentColor", height: "21", viewBox: "0 0 20 21", width: "20", xmlns: "http://www.w3.org/2000/svg", ...l, children: [
    /* @__PURE__ */ C(
      "path",
      {
        clipRule: "evenodd",
        d: "M6.53424 15.2537C4.89131 14.1353 3.80691 12.2401 3.80691 10.0876C3.80691 6.64038 6.58455 3.85474 10.0001 3.85474C13.4156 3.85474 16.1933 6.64038 16.1933 10.0876C16.1933 12.24 15.1089 14.1352 13.4661 15.2536V17.4904C13.4661 19.4287 11.9143 21 10.0001 21C8.08598 21 6.53424 19.4287 6.53424 17.4904V15.2537ZM5.28418 10.0876C5.28418 7.47634 7.39071 5.35063 10.0001 5.35063C12.6095 5.35063 14.716 7.47634 14.716 10.0876C14.716 11.6983 13.9159 13.1235 12.6873 13.9809H7.31285C6.08427 13.1235 5.28418 11.6983 5.28418 10.0876ZM11.9888 15.4767H8.01151V16.2822H11.9888V15.4767ZM10.0001 19.5041C8.99831 19.5041 8.1695 18.754 8.03165 17.7781H11.9686C11.8308 18.754 11.002 19.5041 10.0001 19.5041Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M9.09091 0.920543C9.09091 0.412141 9.49792 0 10 0C10.5021 0 10.9091 0.412141 10.9091 0.920543V2.8186C10.6113 2.781 10.3079 2.76163 10 2.76163C9.69213 2.76163 9.38872 2.781 9.09091 2.8186V0.920543Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M5.54037 4.30823L4.21464 2.96581C3.85962 2.60631 3.28402 2.60631 2.929 2.96581C2.57397 3.3253 2.57397 3.90816 2.929 4.26765L4.25471 5.61007C4.628 5.12382 5.06017 4.68622 5.54037 4.30823Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M2.78354 9.20543H0.909091C0.407014 9.20543 0 9.61757 0 10.126C0 10.6344 0.407014 11.0465 0.909091 11.0465H2.78354C2.7464 10.745 2.72727 10.4377 2.72727 10.126C2.72727 9.81422 2.7464 9.50699 2.78354 9.20543Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M17.2165 11.0465H19.0909C19.593 11.0465 20 10.6344 20 10.126C20 9.61757 19.593 9.20543 19.0909 9.20543H17.2165C17.2536 9.50699 17.2727 9.81422 17.2727 10.126C17.2727 10.4377 17.2536 10.745 17.2165 11.0465Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ C(
      "path",
      {
        d: "M15.7455 5.61029L17.0713 4.26774C17.4263 3.90824 17.4263 3.32539 17.0713 2.96589C16.7163 2.6064 16.1407 2.6064 15.7857 2.96589L14.4598 4.30841C14.94 4.68641 15.3722 5.12403 15.7455 5.61029Z",
        fill: "currentColor"
      }
    )
  ] });
}
export {
  o as default
};
